import { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  Spinner,
} from "reactstrap";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Simple bar
import BreadCrumb from "../../Components/Common/BreadCrumb";
import classnames from "classnames";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { Link, useHistory, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import { useFormation, useValidateFormation } from "../../hooks/useFormations";
import { normalizeBackendFileUrl } from "../../utils/backendApi";
import defaultFormationImage from "../../assets/images/lcbtp.png";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function FormationsDetail(props) {
  const history = useHistory();

  const formationId = useParams();
  const id = formationId?.id;

  const formationQ = useFormation(id);
  const validateMutation = useValidateFormation();
  const formation = formationQ.data || {};

  const errorMessage =
    typeof formationQ.error === "string"
      ? formationQ.error
      : formationQ.error?.message || "Erreur";

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      published: false,
    },

    validationSchema: Yup.object({
      published: Yup.boolean(),
    }),

    onSubmit: (values) => {
      if (!values.published) {
        toast.error(props.t("Veuillez cocher la case de vérification"), {
          autoClose: 3000,
        });
        return;
      }

      validateMutation.mutate(id, {
        onSuccess: () => {
          history.push("/formations");
          validation.resetForm();
        },
      });
    },
  });

  if (!id) return <Loader error={props.t("Identifiant manquant")} />;
  if (formationQ.isLoading) return <Loader />;
  if (formationQ.isError) return <Loader error={errorMessage} />;

  const modeLabel =
    formation.mode === "online"
      ? "En ligne"
      : formation.mode === "on-site"
        ? "En présentiel"
        : formation.mode || props.t("(Non Renseigné)");
  const formationImageUrl = normalizeBackendFileUrl(formation.formation_file);
  // The attachment is rendered as an image, so a PDF or a document shows up as
  // a broken image with no way to open it. A link is offered for those.
  const isImageAttachment =
    !formationImageUrl ||
    /\.(png|jpe?g|gif|webp|avif|svg)$/i.test(formationImageUrl);

  document.title = props.t("Détail d'une formation");
  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer closeButton={false} />
        <BreadCrumb
          title={props.t("Détail d'une formation")}
          pageTitle={props.t("Formations")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                      <Row>
                        <Col lg={6}>
                          <img
                            src={
                              isImageAttachment
                                ? formationImageUrl || defaultFormationImage
                                : defaultFormationImage
                            }
                            className="rounded"
                            style={{ width: "100%" }}
                            alt=""
                            onError={(e) => {
                              e.currentTarget.src = defaultFormationImage;
                            }}
                          />
                          {formationImageUrl && !isImageAttachment ? (
                            <a
                              href={formationImageUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-soft-primary btn-sm mt-2"
                            >
                              <i className="ri-file-line align-bottom me-1"></i>
                              {props.t("Voir le document")}
                            </a>
                          ) : null}
                        </Col>
                        <Col lg={6}>
                          <div className="product-content ">
                            <Nav tabs className="nav-tabs-custom nav-warning">
                              <NavItem>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: customActiveTab === "1",
                                  })}
                                  onClick={() => {
                                    toggleCustom("1");
                                  }}
                                >
                                  {props.t("Détails")}
                                </NavLink>
                              </NavItem>
                            </Nav>

                            <TabContent
                              activeTab={customActiveTab}
                              className="border border-top-0 p-4"
                              id="nav-tabContent"
                            >
                              <TabPane id="nav-speci" tabId="1">
                                <div className="table-responsive">
                                  <table className="table mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Statut")}
                                        </th>
                                        <td
                                          className="text-blue-500"
                                          style={{ color: "blue" }}
                                        >
                                          {!formation.published ? (
                                            <div
                                              className="fs-12 uppercase badge badge-soft-danger"
                                              style={{
                                                textAlign: "center",
                                                fontSize: "13px",
                                              }}
                                            >
                                              {" "}
                                              En attente
                                            </div>
                                          ) : (
                                            <div
                                              className="fs-12 uppercase badge badge-soft-success"
                                              style={{
                                                textAlign: "center",
                                                fontSize: "13px",
                                              }}
                                            >
                                              {" "}
                                              Validé
                                            </div>
                                          )}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Auteur")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.initiator &&
                                            formation.initiator.username}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Domaine")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.domain}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Formateur")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.formateur}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row"> {props.t("Lieu")} </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.lieu}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Audience")}{" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.audiance}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row"> {props.t("Mode")} </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {modeLabel}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Date de début")} {" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.start_date ||
                                            props.t("(Non Renseigné)")}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Date de fin")} {" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.end_date ||
                                            props.t("(Non Renseigné)")}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Début des inscriptions")} {" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.registration_start ||
                                            props.t("(Non Renseigné)")}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Fin des inscriptions")} {" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.registration_end ||
                                            props.t("(Non Renseigné)")}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row"> {props.t("Lien")} </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.formation_link ? (
                                            <a
                                              href={formation.formation_link}
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              {formation.formation_link}
                                            </a>
                                          ) : (
                                            props.t("(Non Renseigné)")
                                          )}
                                        </td>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          {" "}
                                          {props.t("Inscrits")} {" "}
                                        </th>
                                        <td
                                          className="text-red-500"
                                          style={{ fontStyle: "italic" }}
                                        >
                                          {formation.registers_count || 0}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </TabPane>
                            </TabContent>
                          </div>
                        </Col>
                      </Row>
                      <div className="d-flex">
                        <div className="flex-wrap gap-3">
                          <br></br>
                          <h2> {formation.title}</h2>
                        </div>
                      </div>
                      <div
                        className="mt-4 text-muted"
                        style={{ textAlign: "justify" }}
                      >
                        <p>{formation.description}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
                {!formation.published ? (
                  <Form
                    encType="multipart/form-data"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <br></br>
                    <input
                      type="checkbox"
                      name="published"
                      className="form"
                      style={{
                        fontWeight: "30px",
                        width: "20px",
                        height: "20px",
                        marginRight: "5px",
                      }}
                      onChange={validation.handleChange}
                    />
                    <b> J'ai vérifié cette formation </b>
                    <div className="text-end mb-3">
                      <Link to="/formations" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                      <button
                        type="submit"
                        className="btn btn-warning m-2"
                        disabled={validateMutation.isPending}
                      >
                        {validateMutation.isPending && (
                          <Spinner size="sm" className="me-2" />
                        )}
                        {props.t("Valider la formation")}
                      </button>
                    </div>
                  </Form>
                ) : (
                  <div className="text-end mb-3">
                    <Link to="/formations" className="btn btn-warning me-2">
                  {props.t("Retour")}
                </Link>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

FormationsDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(FormationsDetail));
